module.exports = __webpack_public_path__ + "img/upload.0f0c67ad.png";